import { render, staticRenderFns } from "./SearchCompany.vue?vue&type=template&id=a1131dfe&scoped=true&"
import script from "./SearchCompany.vue?vue&type=script&lang=js&"
export * from "./SearchCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchCompany.vue?vue&type=style&index=0&id=a1131dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1131dfe",
  null
  
)

export default component.exports